<template>
    <div class="audioPlay" @mousedown="clearTimer" @mouseup="audioPlay">
        <span v-if="!status" @click.stop="audioPlay" class="play" @mousedown.stop @mouseup.stop>
            <span class="playicon"></span>
        </span>
        <span v-if="status" @click.stop="audioPause" class="pause" @mousedown.stop @mouseup.stop>
            <span class="pauseicon"></span>
            <span class="pauseicon"></span>
        </span>
        <!-- <span class="time">{{totalTime}}</span> -->
        <el-slider v-model="progress" @change="progressChange" :format-tooltip="currentTime"></el-slider>
        <!-- <span class="schedule">
            <span class="scheduleActive"></span>
            <span class="scheduleBtn"></span>
        </span> -->
        <span class="volume"></span>
        <span class="schedule">
            <span class="scheduleActive"></span>
            <span class="scheduleBtn"></span>
        </span>
    </div>
</template>
<script>
export default {
    props: ['src'],
    data(){
        return{
            audio:null,
            duration:0,
            status:false,
            autoLoad:false,
            autoPlay:false,
            progress:0,
            progressTimer:null
        }
    },
    methods: {
        audioLoad(){
            this.audio = document.createElement('audio')
            this.audio.src = this.src
            document.body.appendChild(this.audio)
            this.getDuration()
        },
        getDuration(){
            this.isLoad()
            .then(()=>{
                this.duration = this.audio.duration
            })
        },
        audioPlay(){
            if(!this.autoLoad&&!this.audio){
                this.audioLoad()
            }
            this.audio.play()
            this.progressListen()
            this.status = true
        },
        audioPause(){
            clearInterval(this.progressTimer)
            this.audio.pause()
            this.status = false
        },
        progressListen(){
            clearInterval(this.progressTimer)
            this.progressTimer = setInterval(()=>{
                this.progress = this.audio.currentTime/this.duration*100
                if(this.audio.currentTime == this.duration){
                    this.status = false
                    this.progress = this.audio.currentTime = 0
                    clearInterval(this.progressTimer)
                }
            },100)
        },
        progressChange(data){
            clearInterval(this.progressTimer)
            this.audioPlay()
            this.isLoad()
            .then(()=>{
                this.progress = data
                this.audio.currentTime = this.duration * this.progress/100
                this.progressListen()
            })
        },
        clearTimer(){
            clearInterval(this.progressTimer)
        },
        showTime(num){
            let time = Math.floor(num)
            let second = (time%60).toString().padStart(2,0)
            let minute = Math.floor(time/60).toString().padStart(2,0)
            return minute+':'+second
        },
        currentTime(){
            if(!this.audio) return 0
            return this.showTime(this.audio.currentTime)
        },
        isLoad(){
            return new Promise((resolve,reject)=>{
                let timer = setInterval(()=>{
                    if(this.audio.duration){
                        clearInterval(timer)
                        resolve()
                    }
                },100)
            })
        }
    },
    mounted () {
        if(this.autoLoad){
            this.audioLoad()
        }
        if(this.autoPlay){
            this.audioPlay()
        }
    },
    beforeDestroy(){
        document.querySelectorAll('audio').forEach(element => {
            element.pause()
            element.parentNode.removeChild(element)
        });
    },
    computed: {
        totalTime(){
            return this.showTime(this.duration)
        },
    }
}
</script>
<style lang="less">
.audioPlay{
    background: #F3F3F3;
    display: inline-block;
    width: 154px;
    height: 30px;
    padding: 7px 10px;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    .play{
        cursor: pointer;
        float: left;
        margin-right: 10px;
        border: 1px solid #5A75F6;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: relative;
        box-sizing: border-box;
        .playicon{
            width: 0;
            height: 0;
            border-top:5px solid transparent;
            border-bottom:5px solid transparent;
            border-left:5px solid #5A75F6;
            border-right:5px solid transparent;
            display: block;
            position: absolute;
            left: 5px;
            top: 2px;
        }
    }
    .pause{
        cursor: pointer;
        float: left;
        margin-right: 10px;
        border: 1px solid #5A75F6;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: relative;
        .pauseicon{
            width: 2px;
            height: 8px;
            float: left;
            display: block;
            background: #5A75F6;
            margin-top: 3px;
        }
        .pauseicon:nth-of-type(1){
            margin-left: 4px;
            margin-right: 2px;
        }
    }
    .time{
        float: left;
        margin-right: 10px;
    }
    .el-slider{
        float: left;
        width: 106px;
        height: 16px;
        display: inline-block;
        .el-slider__runway{
            margin: 5px 0;
        }
        .el-slider__button{
            width: 10px;
            height: 10px;
        }
        .el-slider__button-wrapper{
            z-index: 1;
        }
    }
}
</style>






// WEBPACK FOOTER //
// packages/question-single/src/audioPlay.vue